import React from 'react'
import css from './chartLegend.css'
type AdditionalValues = Record<string, string>
type Props = {
  payload?: any
  additionalValues: AdditionalValues
}

const ChartLegend = (props: Props) => {
  const { payload, additionalValues } = props
  return (
    <div className={css.legend}>
      {payload?.map((entry, index) => {
        return (
          <span key={`item-${index}`}>
            <span
              className={css.line}
              style={{
                borderColor: entry.color,
              }}
            />
            <span>{entry.value}</span>
            {<span className={css.additionalValue}>{additionalValues[entry.value]}</span>}
          </span>
        )
      })}
    </div>
  )
}

export default ChartLegend
